export var TranslationKeys;
(function (TranslationKeys) {
    // Required
    TranslationKeys["Open"] = "open";
    TranslationKeys["Close"] = "close";
    TranslationKeys["Download"] = "download";
    TranslationKeys["VisitUrl"] = "visit-url";
    TranslationKeys["PreviewImage"] = "preview-image";
    TranslationKeys["RenderErrorWhenOffline"] = "render-error-when-offline";
    TranslationKeys["RenderErrorNoLowQualityPreview"] = "render-error-no-low-quality-preview";
    TranslationKeys["RenderError"] = "render-error";
    TranslationKeys["ThreeJsViewIn3d"] = "three-js-view-in-3d";
    TranslationKeys["ThreeJsWebglNotSupported"] = "three-js-webgl-not-supported";
    TranslationKeys["ThreeJsUnsupportedFile"] = "three-js-unsupported-file";
    TranslationKeys["ThreeJsReadMore"] = "three-js-read-more";
    TranslationKeys["ThreeJsLoadingModel"] = "three-js-loading-model";
    TranslationKeys["ThreeJsFtueOrbitTitle"] = "three-js-ftue-orbit-title";
    TranslationKeys["ThreeJsFtueOrbitDescriptionMouse"] = "three-js-ftue-orbit-description-mouse";
    TranslationKeys["ThreeJsFtueOrbitDescriptionTouch"] = "three-js-ftue-orbit-description-touch";
    TranslationKeys["ThreeJsFtueZoomTitle"] = "three-js-ftue-zoom-title";
    TranslationKeys["ThreeJsFtueZoomDescriptionMouse"] = "three-js-ftue-zoom-description-mouse";
    TranslationKeys["ThreeJsFtueZoomDescriptionTouch"] = "three-js-ftue-zoom-description-touch";
    TranslationKeys["ThreeJsFtuePanTitle"] = "three-js-ftue-pan-title";
    TranslationKeys["ThreeJsFtuePanDescriptionMouse"] = "three-js-ftue-pan-description-mouse";
    TranslationKeys["ThreeJsFtuePanDescriptionTouch"] = "three-js-ftue-pan-description-touch";
    TranslationKeys["ThreeJsRenderErrorTitle"] = "three-js-render-error-title";
    TranslationKeys["ThreeJsRenderErrorBody"] = "three-js-render-error-body";
    TranslationKeys["ToggleThumbnails"] = "toggle-thumbnails";
    TranslationKeys["SwitchToSinglePageView"] = "switch-to-single-page-view";
    TranslationKeys["SwitchToContinuousScrollView"] = "switch-to-continuous-scroll-view";
    TranslationKeys["ZoomIn"] = "zoom-in";
    TranslationKeys["ZoomOut"] = "zoom-out";
    // Search Component
    TranslationKeys["SearchComponentNoResults"] = "search-component-no-results";
    TranslationKeys["SearchComponentSearchDocument"] = "search-component-search-document";
    TranslationKeys["SearchComponentIsUnavailable"] = "search-component-is-unavailable";
    // Optional
    TranslationKeys["OpenInPowerpoint"] = "open-in-powerpoint";
    TranslationKeys["OpenInExcel"] = "open-in-excel";
    TranslationKeys["OpenInWord"] = "open-in-word";
    TranslationKeys["OfficeOnlineBarPowerpointMessage"] = "office-online-bar-powerpoint-message";
    TranslationKeys["OfficeOnlineBarExcelMessage"] = "office-online-bar-excel-message";
    TranslationKeys["OfficeOnlineBarWordMessage"] = "office-online-bar-word-message";
})(TranslationKeys || (TranslationKeys = {}));
//# sourceMappingURL=Translations.type.js.map